import { render } from "./MarkAsButton.vue?vue&type=template&id=67e37517&scoped=true&ts=true"
import script from "./MarkAsButton.vue?vue&type=script&lang=ts"
export * from "./MarkAsButton.vue?vue&type=script&lang=ts"

import "./MarkAsButton.vue?vue&type=style&index=0&id=67e37517&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e37517"]])

export default __exports__